import React, { useEffect, useState } from "react";
import { Plus, X, Eye, EyeSlash } from "@phosphor-icons/react";
import { useSettings } from "@/context/SettingsContext";

export const Header = ({ title, action }) => (
  <div className="flex items-center justify-between mb-8 flex-wrap gap-4">
    <h1 className="font-display text-4xl sm:text-5xl uppercase">{title}</h1>
    {action}
  </div>
);

export const AddBtn = ({ onClick, label, testid }) => (
  <button data-testid={testid} onClick={onClick} className="bg-[#FF5722] hover:bg-[#FF7043] text-black font-bold uppercase tracking-wide px-5 py-2.5 flex items-center gap-2 transition-all duration-200 text-sm">
    <Plus size={18} weight="bold" /> {label}
  </button>
);

export const Modal = ({ open, onClose, title, children }) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={onClose}>
      <div className="bg-[#121212] border border-white/10 w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="admin-modal">
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10 sticky top-0 bg-[#121212]">
          <h3 className="font-display text-2xl uppercase">{title}</h3>
          <button onClick={onClose} className="text-white/50 hover:text-white"><X size={22} /></button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
};

export const In = ({ label, type, ...props }) => {
  const [show, setShow] = useState(false);
  const isPw = type === "password";
  return (
    <div>
      <label className="block text-xs font-semibold uppercase tracking-wide text-white/60 mb-1.5">{label}</label>
      <div className="relative">
        <input
          {...props}
          type={isPw && show ? "text" : type}
          className={`w-full bg-[#1A1A1A] border border-white/15 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF5722] transition-all ${isPw ? "pr-11" : ""}`}
        />
        {isPw && (
          <button
            type="button"
            onClick={() => setShow((s) => !s)}
            aria-label={show ? "Hide password" : "Show password"}
            data-testid={props["data-testid"] ? `${props["data-testid"]}-toggle` : "password-toggle"}
            className="absolute inset-y-0 right-0 flex items-center px-3 text-white/40 hover:text-[#FF5722] transition-colors"
          >
            {show ? <EyeSlash size={18} /> : <Eye size={18} />}
          </button>
        )}
      </div>
    </div>
  );
};

export const Sel = ({ label, children, ...props }) => (
  <div>
    <label className="block text-xs font-semibold uppercase tracking-wide text-white/60 mb-1.5">{label}</label>
    <select {...props} className="w-full bg-[#1A1A1A] border border-white/15 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#FF5722] transition-all">{children}</select>
  </div>
);

export const SaveBtn = ({ loading, testid }) => (
  <button type="submit" disabled={loading} data-testid={testid} className="w-full bg-[#FF5722] hover:bg-[#FF7043] disabled:opacity-50 text-black font-bold uppercase tracking-wide py-3 transition-all duration-200 mt-2">
    {loading ? "Saving..." : "Save"}
  </button>
);

export const IconBtn = ({ onClick, danger, children, testid }) => (
  <button data-testid={testid} onClick={onClick} className={`p-2 transition-colors ${danger ? "text-white/40 hover:text-[#FF3B30]" : "text-white/40 hover:text-[#FF5722]"}`}>{children}</button>
);

export const Stepper = ({ onClick, children, testid }) => (
  <button type="button" data-testid={testid} onClick={onClick} className="w-7 h-7 flex items-center justify-center border border-white/15 hover:border-[#FF5722] hover:text-[#FF5722] text-white/70 text-lg leading-none transition-all duration-200">{children}</button>
);

export const DivisionTabs = ({ value, onChange, prefix }) => {
  const { settings } = useSettings();
  const DIVISIONS = settings.divisions || [];
  useEffect(() => {
    if (DIVISIONS.length && !DIVISIONS.includes(value)) onChange(DIVISIONS[0]);
  }, [DIVISIONS, value]); // eslint-disable-line
  return (
    <div className="flex flex-wrap gap-2 mb-6">
      {DIVISIONS.map((d) => (
        <button
          key={d}
          data-testid={`${prefix}-division-${d.replace(/\s+/g, "-").toLowerCase()}`}
          onClick={() => onChange(d)}
          className={`px-5 py-2 text-sm font-bold uppercase tracking-wide transition-all duration-200 ${
            value === d ? "bg-[#FF5722] text-black" : "border border-white/15 text-white/70 hover:text-white"
          }`}
        >
          {d}
        </button>
      ))}
    </div>
  );
};
